export const KBA_STATUSES = ["PENDING", "IN_PROGRESS", "DECLINED", "ACTIVE", "INACTIVE"];

export const KBA_DECLINE_REASON_MAX_LENGTH = 1000;

export const normalizeKbaKey = (key) => (key || "").trim().toUpperCase();

export const isKbaKeyValid = (key) => /^[A-Za-z0-9]{5}$/.test(key || "");

// INACTIVE is reachable from any status (kill switch); from INACTIVE the
// only way back is via IN_PROGRESS so the key re-enters the normal lifecycle
// instead of jumping straight to PENDING or ACTIVE. DECLINED (KBA rejected
// the registration) follows the same rule: back out only via IN_PROGRESS.
// Mirrors KbaStatus.canTransitionTo on the backend.
export const canTransitionKbaStatus = (currentStatus, targetStatus) => {
  if (!currentStatus || !targetStatus || currentStatus === targetStatus) {
    return false;
  }

  if (targetStatus === "INACTIVE") {
    return true;
  }

  const transitions = {
    PENDING: ["IN_PROGRESS", "DECLINED"],
    IN_PROGRESS: ["PENDING", "ACTIVE", "DECLINED"],
    ACTIVE: ["IN_PROGRESS"],
    INACTIVE: ["IN_PROGRESS"],
    DECLINED: ["IN_PROGRESS"],
  };

  return transitions[currentStatus]?.includes(targetStatus) || false;
};

export const getKbaStatusStyle = (status) => {
  switch (status) {
    case "ACTIVE":
      return {background: "#e6f4ea", color: "#137333", borderColor: "#a8dab5"};
    case "IN_PROGRESS":
      return {background: "#fff4e5", color: "#9a6700", borderColor: "#f6d58f"};
    case "PENDING":
      return {background: "#f1f3f4", color: "#3c4043", borderColor: "#d9dce0"};
    case "INACTIVE":
      return {background: "#eeeeee", color: "#6f7275", borderColor: "#d0d0d0"};
    case "DECLINED":
      return {background: "#fce8e6", color: "#c5221f", borderColor: "#f4b4ae"};
    default:
      return {background: "#f1f3f4", color: "#3c4043", borderColor: "#d9dce0"};
  }
};
